// src/v3/interactions/arrow-up.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var ArrowUpIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "ArrowUpIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M19.2807 11.0306C19.211 11.1004 19.1283 11.1557 19.0373 11.1934C18.9462 11.2312 18.8486 11.2506 18.7501 11.2506C18.6515 11.2506 18.5539 11.2312 18.4628 11.1934C18.3718 11.1557 18.2891 11.1004 18.2194 11.0306L12.7501 5.56032V20.25C12.7501 20.4489 12.671 20.6397 12.5304 20.7803C12.3897 20.921 12.199 21 12.0001 21C11.8011 21 11.6104 20.921 11.4697 20.7803C11.3291 20.6397 11.2501 20.4489 11.2501 20.25V5.56032L5.78068 11.0306C5.63995 11.1714 5.44907 11.2504 5.25005 11.2504C5.05103 11.2504 4.86016 11.1714 4.71943 11.0306C4.5787 10.8899 4.49963 10.699 4.49963 10.5C4.49963 10.301 4.5787 10.1101 4.71943 9.96938L11.4694 3.21939C11.5391 3.14965 11.6218 3.09433 11.7128 3.05659C11.8039 3.01885 11.9015 2.99942 12.0001 2.99942C12.0986 2.99942 12.1962 3.01885 12.2873 3.05659C12.3783 3.09433 12.461 3.14965 12.5307 3.21939L19.2807 9.96938C19.3504 10.039 19.4057 10.1218 19.4435 10.2128C19.4812 10.3039 19.5006 10.4014 19.5006 10.5C19.5006 10.5986 19.4812 10.6962 19.4435 10.7872C19.4057 10.8783 19.3504 10.961 19.2807 11.0306Z"
  }
) });

export {
  ArrowUpIcon
};
